import { useCallback, useState, useEffect } from 'react'
import {
  ApiErrorResponse,
  getKyousouApiClient,
  handleError,
} from '../services/network'
import { useSnackBar } from '../providers/snack_bar_provider'

/**
 * 企業お気に入り機能のカスタムフック
 */
export const useEnterpriseFavorite = (
  enterpriseId: string | undefined,
  initialIsFavorited?: boolean
) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isFavorited, setIsFavorited] = useState(initialIsFavorited ?? false)

  useEffect(() => {
    setIsFavorited(initialIsFavorited ?? false)
  }, [initialIsFavorited])

  /**
   * 企業をお気に入りする
   */
  const toggleFavorite = useCallback(async () => {
    if (!enterpriseId) {
      return
    }
    try {
      await apiClient.enterprise.favoriteCreate({
        kuchikomiEnterpriseId: enterpriseId,
        set: !isFavorited,
      })
      setIsFavorited(!isFavorited)
    } catch (error) {
      console.error('お気に入りの更新に失敗しました', error)
      handleError(error as ApiErrorResponse, showSnackBar)
    }
  }, [enterpriseId, isFavorited, apiClient, showSnackBar])

  return {
    isFavorited,
    toggleFavorite,
  }
}
